import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-success\"><path d=\"M0 512a512 512 0 101024 0A512 512 0 100 512z\" fill=\"#00B359\" /><path d=\"M460.8 768L215.04 552.96c-20.48-10.24-30.72-51.2-10.24-71.68 20.48-20.48 51.2-20.48 71.68 0l174.08 153.6 348.16-307.2c20.48-20.48 51.2-20.48 71.68 0 20.48 20.48 20.48 51.2 0 71.68L460.8 768z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol